<template>
	<b-row class="mb-3">
			
					<b-col lg="8" sm="12">
						<b-card>
							<b-row class="p-3">
								<b-col lg="5" sm="12"> 
								<!-- <b-form-file type="file" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose Company Logo "></b-form-file> -->
								 <!-- <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img> -->
								  <span v-if="business.business_logo!=null">
								 <p class="mb-2 text-center" v-if="business.business_logo!= null">
									<b-img  v-bind="thumbnailProps"  rounded alt=""  :src="$root.MEDIAPATH+'businesslogo/'+business.business_logo"></b-img>
								 </p>
								 <p class="mb-2 text-center" v-if="editLogo==1">
									<small class="info">
									<b-link  @click="editLogo=0"> <i class="fa fa-pencil"></i> Edit Logo</b-link>  </small>
								 </p>
								 </span>
								<p class="mb-3" v-if="editLogo==0">
								<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose Business Logo" label-size="sm"></b-form-file>
								</p>
								<b-form-text id="password-help-block"> </b-form-text>
								 <b-form-group :state="businessState.business_name" label="Company/Business Name" label-for="sa-bname" invalid-feedback="Company/Business name is required!" label-size="sm" >
									<b-form-input id="sa-bname" v-model="business.business_name" :state="businessState.business_name" @focusin="businessState.business_name = null" size="sm" placeholder="Enter company/business name" ></b-form-input>
								</b-form-group>
								 
								
								</b-col>
								<b-col lg="7" sm="12">
									<b-row>
										
										<b-col class="flex-row" > 
											<b-form-group :state="businessState.pan" label="PAN Number" label-for="sa-pan" invalid-feedback="Company/Business name is required!" label-size="sm">
												<b-form-input id="sa-pan" v-model="business.pan" :state="businessState.pan" @focusin="businessState.pan = null" size="sm" placeholder="Enter PAN number" ></b-form-input>
											</b-form-group>
										</b-col>
										<b-col class="flex-row" > 
											<b-form-group :state="businessState.gst" label="GST Number" label-for="sa-gst" invalid-feedback="GST number is required!" label-size="sm">
												<b-form-input id="sa-gst" v-model="business.gst" :state="businessState.gst" @focusin="businessState.gst = null" size="sm" placeholder="Enter GST number" ></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
									
									<b-col >
										<b-row class="mt-3">
											<b-col class="flex-row">
												<div role="group" style="width:100%;">
													
												 <label for="input-live" class="col-form-label-sm">Enter your Address/Communication Address</label>
												
												<b-form-textarea
												v-model="business.communication_address"
												size="sm"
												  id="textarea"							     
												  placeholder="Enter Address"							      
												style="min-width: 100%" ></b-form-textarea>
												</div>

											</b-col>
										</b-row>
										<p class="text-right" style="width:100%" v-if="addOfficeaddress==0"> <small class="info" info>
											<b-link  @click="addOfficeaddress=1"><b-icon class="mr-2" icon="plus-circle" aria-hidden="true"></b-icon>Add Register Office Address</b-link>  </small></p>

											<b-row class="mt-3" v-if="addOfficeaddress==1">
												<b-col class="flex-row">
													<div role="group" style="width: 100%;">
														
													 <label for="input-live" class="col-form-label-sm">Register Office Address</label>
													
													<b-form-textarea	
													v-model="business.office_address"
													size="sm"
													  id="textareava"
													  placeholder="Enter Address"							      
													></b-form-textarea>
													</div>

												</b-col>
												
											</b-row>
											<p class="text-right"  v-if="addOfficeaddress==1"> <small class="info" info>
												<b-link  @click="addOfficeaddress=0">Cancel</b-link>  </small></p>
									</b-col>

								</b-row>


								
								</b-col>
							</b-row>
							
						
							

							<b-row class="pb-3 pr-3">
								<b-col class=" text-right">
									<b-button variant="dark" pill  @click="saveProfile()"><b-icon class="mr-2" icon="upload" aria-hidden="true"></b-icon>Save Profile</b-button>
								</b-col>
							</b-row>
						</b-card>
					</b-col>
					<b-col lg="4" sm="12">
							<!--<b-card class="mb-2">
							<b-row>
							<b-col class="flex-row"> 
									<b-form-file type="file" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose Company Logo "></b-form-file>
									<b-form-text id="password-help-block"> </b-form-text>
							</b-col> 
							</b-row> 
							</b-card>-->
							
								<b-card class="pl-3 pr-3 pt-3 pb-0">
									<h6 class="text-center">Seller Agreement <br /></h6>  
									<profile-kyc></profile-kyc>
								</b-card>

							
							
							<b-card class="p-3">
								<h6>Customer Support</h6>  
								<b-form-checkbox v-model="customerSupport" id="customerSupport-a" value="1" unchecked-value="0"> 
									Same as Account Details
								</b-form-checkbox>
						
								<ul v-if="customerSupport==1">
									<li><small>Email: <strong>{{$root.customer_info.email}}</strong></small></li>
									<li><small>Phone: <strong>{{$root.customer_info.phone}}</strong></small></li>
								</ul>
								
								<ul v-else>
									<li>
									
									
									
										<b-form-group :state="cscontactState.cs_email" label="Email" label-size="sm" label-cols-sm="4" label-cols-lg="3"  content-cols-sm content-cols-lg="7" label-for="input-horizontal" invalid-feedback="Email should be valid!" >
											<b-form-input class="mb-0"  v-model="csContact.cs_email" size="sm" :state="cscontactState.cs_email" @focusin="cscontactState.cs_email = null"></b-form-input>
										</b-form-group>
										
										<b-form-group label-for="phone-input" label-size="sm" label-class="mb-4" class="mb-1" :state="cscontactState.cs_phone" :invalid-feedback="csContactError.cs_phone" label-cols-sm="3" content-cols-sm label="Phone" > 
							<b-form-input  :state="cscontactState.cs_phone" v-model="csContact.cs_phone"  @focusin="cscontactState.cs_phone = null" size="sm" maxlength="11"  ></b-form-input>
							</b-form-group>
							
										
										<!--<b-form-group :state="cscontactState.cs_phone" label="Phone" label-size="sm" label-cols-sm="4"       label-cols-lg="3"  content-cols-sm content-cols-lg="7" label-for="input-horizontal" invalid-feedback="Email should be valid!">
											<b-form-input class="mb-0" v-model="csContact.cs_phone" size="sm"  :state="cscontactState.cs_phone" @focusin="cscontactState.cs_phone = null"></b-form-input>
										</b-form-group>		-->							
									</li>
									<li class="text-right"><b-button  variant="dark" pill  @click="saveProfilecs()">Save customer support</b-button></li>
									
								</ul>
								
								<ul>
									<li></li>
									
								</ul>
								
								
							</b-card>
							
							
							<!--<b-card class="p-3">
								<h6>Add Brand Name</h6>  
								<b-form-checkbox v-model="business.brandas" id="checkbox-a" value="1" unchecked-value="0"> 
									Same as Company Name
								</b-form-checkbox>
						
								<ul>
									<li>Brand Name: <b-link  href="/seller/brands"> name</b-link> </li>
									<li> <small class="info" info><b-link  href="/seller/brands"><b-icon class="mr-2" icon="plus-circle" aria-hidden="true"></b-icon>Add another brand</b-link>  </small></li>
								</ul>
								
							</b-card> -->
							
						
					</b-col>
				</b-row>
				
				
	</template>
<script>
import ProfileKyc from "@/components/profile-kyc.vue";
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'ProfileBusiness',
  components: {
  //"cart-variant": CartVariant,
  "profile-kyc": ProfileKyc,
  },
  props: {
   /* profile: { type: Object },
    cartData: { type: Object  }, 
	cartTotalqty:Number,*/
  },
  mounted(){
  this.inLodcard();
  //this.initProfile();
  
  },
  computed: {
    //
  },
  data() {
    return{
		recordUrl: this.$root.NEWAPIURL+'profileapi/load-business',
		uploadBusUrl: this.$root.NEWAPIURL+'profileapi/upload_profilebusiness', 
		uploadCSUrl: this.$root.NEWAPIURL+'profileapi/upload_profilecustomersupport', 
		editField : '',
		addOfficeaddress:0,
		business:{
				business_name:'',
				business_logo:'',
				pan:'',
				gst:'',
				office_address:'',
				communication_address:'',
				brandas:'',
			},
		businessState:{
			business_name:null,
			business_logo:null,
			pan:null,
			gst:null,
			office_address:null,
			communication_address:null,
			brandas:null,
		},
		shippingaddress:{},
		product_inf:{},
		thumbnailProps: { blank: false, width: 80, height: 80, class: 'm1' },
		editLogo:0,
		customerSupport:0,
		csContact:{
			cs_email:'',
			cs_phone:''
		},
		cscontactState:{
			cs_email:null,
			cs_phone:null
			
		},
		csContactError:{
			cs_email:null,
			cs_phone:'Please enter Phone number!',
			
		},
		
		
	}
  },
  methods:{
	inLodcard(){
			var self = this;			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var tmp = response.data.result;
					
					//console.log('Muygahs'+tmp);
					if(tmp!=null){
					self.business = Object.assign({}, tmp);
					}
					if(self.business.office_address!=''){
					self.addOfficeaddress=1;
					}
					if(self.business.business_logo!= null){
						self.editLogo=1;
					}
					if(tmp!=null){					
					self.csContact = Object.assign({}, tmp.csdetails);
					}
					
					
					//self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		
	},
	saveProfile(){
		//alert('len'+this.shippingaddress.firstname.length);
		var valid = true;
		if(this.business.business_name.length < 3) {
			this.businessState.business_name = false;
			valid = false;
		}else this.businessState.business_name = true;
		
		/* if(this.business.gst.length < 3) {
			this.businessState.gst = false;
			valid = false;
		}else this.businessState.gst = true; */

		

		if(valid){
			var self = this;
			
			
			let formData = new FormData();
			formData.append('imagefile1', this.product_inf.product_image_1);			
			formData.append('data', JSON.stringify(this.business));
            formData.append('accesskey', this.$session.get('access_key'));

            self.axios.post(self.uploadBusUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log("ddd"+response.data);
					//self.shippingaddressData = response.data.result.shippingaddressData;
					//self.showAddaddress=0;
					
					self.business={
						business_name:'',
						business_logo:'',
						pan:'',
						gst:'',
						office_address:'',
						communication_address:'',
						brandas:'',
					};
					self.businessState={
						business_name:null,
						business_logo:null,
						pan:null,
						gst:null,
						office_address:null,
						communication_address:null,
						brandas:null,
					};
					
					self.inLodcard();
					//self.$root.resetCart();
					//self.$router.push('/order-success');
					//console.log(self.share_data);
					//alert(response.data.message);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}else{
					alert(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		}
		

	},
	validateemail(email){
		var atposition=email.indexOf("@");  
		var dotposition=email.lastIndexOf(".");  
		if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
		return false;  
		}else{
		return true;
		}
	},
		saveProfilecs(){
			var valid = true;
				
			if(!this.validateemail(this.csContact.cs_email)){
			  valid = false;
			  this.cscontactState.cs_email = false;
			}else{
			  this.cscontactState.cs_email = true;
			}
			
			if(this.csContact.cs_phone.length<10){
				this.csContactError.cs_phone='Please enter Phone number!';
				valid = false;
				this.cscontactState.cs_phone = false;
			}else if(!/^[0-9]+$/.test(this.csContact.cs_phone)){
				this.csContactError.cs_phone='Phone number should be only digits!';
				valid = false;
				this.cscontactState.cs_phone = false;
			
			}else{
			this.cscontactState.cs_phone= true;
			}
			
			/*if(this.csContact.cs_phone.length < 10) {
				this.cscontactState.cs_phone = false;
				valid = false;
			}else{
				this.cscontactState.cs_phone = true;
			}*/

			
			

				if(valid){
				
					var self = this;
					self.axios.post(self.uploadCSUrl, {
						accesskey: self.$root.customer_info.access_key,
						data: self.csContact						
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							//console.log("ddd"+response.data);
							/*self.shippingaddressData = response.data.result.shippingaddressData;
							self.showAddaddress=0;*/
							
							self.csContact={
								cs_email:'',
								cs_phone:''
								
							};
							self.cscontactState={
								cs_email:null,
								cs_phone:null
							};
							
							self.inLodcard();
							//self.$root.resetCart();
							//self.$router.push('/order-success');
							//console.log(self.share_data);
							//alert(response.data.message);
						}else if(response.data.error == 9){
							self.$root.forceLogout(response.data.message);
						}else{
							alert(response.data.message);
						}
					})
					.catch(function (error) {
						alert(error);
					});
				}
			
		}
	


    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}

</style>
